// extracted by mini-css-extract-plugin
module.exports = {"wavePhoto":"waveLayerMobile_wavePhoto_3GD1I"};